
/*
 * EVOA GLOBAL CURSOR
 * File: assets/evoa-cursor.js
 *
 * Native product cursor with macOS fallback.
 * Supports open Shadow DOM components.
 */

(function () {
  'use strict';

  if (window.__evoaNativeCursorInitialized) {
    return;
  }

  window.__evoaNativeCursorInitialized = true;

  const imageUrl = window.EVOA_CURSOR_IMAGE;

  if (!imageUrl) {
    console.warn('[EVOA Cursor] Missing image URL.');
    return;
  }

  const root = document.documentElement;

  const isMac = /Mac/i.test(navigator.platform);

  const pointerQuery = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  const safeImageUrl = String(imageUrl)
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
    .replace(/[\r\n]/g, '');

  const cursorValue =
    'url("' + safeImageUrl + '") 12 16, auto';

  const shadowRoots = new WeakSet();

  function removeOldCursor() {
    root.classList.remove(
      'evoa-cursor-active',
      'evoa-cursor-ready',
      'evoa-cursor-enabled'
    );

    const overlay = document.getElementById(
      'evoa-cursor-overlay'
    );

    if (overlay) {
      overlay.remove();
    }
  }

  function setGlobalCursor() {
    if (!pointerQuery.matches) {
      root.style.removeProperty('--evoa-cursor-url');
      return;
    }

    root.style.setProperty(
      '--evoa-cursor-url',
      cursorValue
    );
  }

  function createShadowStyle(host) {
    if (!host.shadowRoot) {
      return;
    }

    const shadowRoot = host.shadowRoot;

    if (shadowRoots.has(shadowRoot)) {
      return;
    }

    const isCart = (
      host.tagName.toLowerCase().includes('cart')
    );

    /*
     * On Mac, use a standard cursor inside
     * cart components to avoid invisible
     * pointer behavior.
     */
    const useFallback = isMac && isCart;

    const appliedCursor = useFallback
      ? 'auto'
      : cursorValue;

    const style = document.createElement('style');

    style.setAttribute(
      'data-evoa-shadow-cursor',
      'true'
    );

    style.textContent = `
      @media (hover: hover) and (pointer: fine) {
        :host,
        *,
        *::before,
        *::after,
        dialog,
        dialog::backdrop {
          cursor: ${appliedCursor} !important;
        }
      }
    `;

    shadowRoot.appendChild(style);
    shadowRoots.add(shadowRoot);
  }

  function scan(container) {
    if (!container || !container.querySelectorAll) {
      return;
    }

    container.querySelectorAll('*').forEach(
      function (element) {
        if (element.shadowRoot) {
          createShadowStyle(element);
          scan(element.shadowRoot);
        }
      }
    );
  }

  function initialize() {
    removeOldCursor();
    setGlobalCursor();
    scan(document);

    const observer = new MutationObserver(
      function () {
        scan(document);
      }
    );

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.addEventListener(
      'click',
      function () {
        requestAnimationFrame(function () {
          scan(document);
        });
      },
      true
    );

    document.addEventListener(
      'focusin',
      function () {
        scan(document);
      },
      true
    );

    if (pointerQuery.addEventListener) {
      pointerQuery.addEventListener(
        'change',
        setGlobalCursor
      );
    }

    console.info(
      '[EVOA Cursor] Initialized.',
      { isMac: isMac }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
